import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

export const getPromotion = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/promo-privilege`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getPromotionByID = async (id) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/promo-privilege/${id}`, {
            headers: headers,
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createPromotion = async (body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('title_en', body.title_en)
        formData.append('title_th', body.title_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('note_en', body.note_en)
        formData.append('note_th', body.note_th)
        formData.append('discount', body.discount)
        formData.append('discount_date', body.discount_date)
        formData.append('publish_date', body.publish_date)
        formData.append('end_date', body.end_date)
        formData.append('active', body.active)
        if (body.cover_imgs.length > 0) {
            if(body.cover_imgs[0].file?.file){
                const blob = new Blob([body.cover_imgs[0].file?.file], { type: body.cover_imgs[0].file?.file.type });
                const parts = body.cover_imgs[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.cover_imgs[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.cover_imgs[0].file.size
                });

                formData.append('cover_imgs', file)
            }
            else{
                formData.append('cover_imgs', body.cover_imgs[0].file)
            }
        }
        else{
            formData.append('cover_imgs', null)
        }

        if (body.imgs.length > 0) {
            body.imgs.forEach((imgs, index) => {
                if (imgs.file?.file) {
                    const blob = new Blob([imgs.file.file], { type: imgs.file.file.type });
                    const parts = imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: imgs.file.size
                    });
        
                    formData.append(`imgs`, file);
                } else {
                    formData.append(`imgs`, imgs.file);
                }
            });
        }
        else{
            formData.append('imgs', null)
        }

      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      for (let entry of formData.entries()) {
        console.log('formData createPromotion',entry);
    }
      const response = await instance.post(`/api/mgr/promo-privilege`, formData, {
        headers: headers,

      });
       
  
      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const updatePromotionByID = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('title_en', body.title_en)
        formData.append('title_th', body.title_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('note_en', body.note_en)
        formData.append('note_th', body.note_th)
        formData.append('discount', body.discount)
        formData.append('discount_date', body.discount_date)
        formData.append('publish_date', body.publish_date)
        formData.append('end_date', body.end_date)
        formData.append('active', body.active)

        if (body.cover_imgs.length > 0) {
            body.cover_imgs.forEach((cover_imgs, index) => {
                if (cover_imgs.file?.file) {
                    const blob = new Blob([cover_imgs.file.file], { type: cover_imgs.file.file.type });
                    const parts = cover_imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: cover_imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: cover_imgs.file.size
                    });
        
                    formData.append(`cover_imgs`, file);
                } else {
                    formData.append(`cover_imgs`, cover_imgs.file);
                }
            });
        } else{
            formData.append('cover_imgs', null)
        }

        if (body.imgs.length > 0) {
            body.imgs.forEach((imgs, index) => {
                if (imgs.file?.file) {
                    const blob = new Blob([imgs.file.file], { type: imgs.file.file.type });
                    const parts = imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: imgs.file.size
                    });
        
                    formData.append(`imgs`, file);
                } else {
                    formData.append(`imgs`, imgs.file);
                }
            });
        }
        else{
            formData.append('imgs', null)
        }
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.put(`/api/mgr/promo-privilege/${id}`, formData, {
            headers: headers,
        });

    
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const deletePromotion = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.delete(`/api/mgr/promo-privilege/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const pinnedPromotion = async (queryparams) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/promo-privilege/topnews`, {
            headers:headers,
            params: {...queryparams}
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
}

export const createAndUpdatePinned = async (id,queryparams, body) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
            };
            const response = await instance.post(`/api/mgr/promo-privilege/topnews`, body, {
            headers: headers,
            params: { ...queryparams }
            });
        
            if (response.status === 200) {
            return response;
            } else {
            return null;
            }
    } catch (error) {
        Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
        }).then((result) => {});
    }
};